import chroma from 'chroma-js'

/**
 * Cor usada quando a categoria não tem identificação para derivar uma cor.
 */
const COR_CATEGORIA_SEM_IDENTIFICACAO = '#8c8c8c'

/**
 * Hash estável de 32 bits para uma string.
 * Precisa ser determinístico: a mesma categoria tem que gerar a mesma cor
 * em qualquer tela e em qualquer sessão.
 * @param {String} texto
 * @returns {Number} hash positivo
 */
function hashDeString(texto) {
	let hash = 0
	for (let indice = 0; indice < texto.length; indice++) {
		hash = (hash << 5) - hash + texto.charCodeAt(indice)
		hash |= 0
	}
	return Math.abs(hash)
}

/**
 * Deriva uma cor a partir do identificador da categoria (nome).
 *
 * Substitui o antigo `chroma.random().hex()`, que sorteava uma cor nova a cada
 * renderização: a categoria aparecia com cores diferentes no cadastro, no
 * dashboard e no gráfico de outliers, e mudava a cada navegação.
 *
 * A cor é apenas uma sugestão de exibição para categorias que ainda não têm
 * cor cadastrada — quem persiste a cor é o formulário de cadastro.
 *
 * @param {String} identificador Nome da categoria
 * @returns {String} cor em hexadecimal
 */
export function corDeterministicaDeCategoria(identificador) {
	const chave = String(identificador ?? '')
		.trim()
		.toLowerCase()

	if (!chave) {
		return COR_CATEGORIA_SEM_IDENTIFICACAO
	}

	const hash = hashDeString(chave)

	// Matiz varre todo o círculo; saturação e luminosidade variam em poucos
	// degraus para manter contraste legível sobre fundo claro.
	const matiz = hash % 360
	const saturacao = 0.45 + ((hash >> 9) % 4) * 0.12
	const luminosidade = 0.38 + ((hash >> 17) % 3) * 0.09

	return chroma.hsl(matiz, saturacao, luminosidade).hex()
}

export { COR_CATEGORIA_SEM_IDENTIFICACAO }
